import { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import RSVPButton from './button';
import "./Rsvp.css";

export default function RSVP({ isOpened = false, setState }) {
  const [open, setOpen] = useState(isOpened);
  const [submitted, setSubmitted] = useState(false);
  const formRef = useRef(null);
const [errors, setErrors] = useState({});

const validate = () => {
  const newErrors = {};

  if (!form.firstName.trim()) newErrors.firstName = !form.firstName.trim();
  if (!form.lastName.trim()) newErrors.lastName = true;
  if (!form.phone.trim()) newErrors.phone = true;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!form.email.trim()|| !emailPattern.test(form.email)) newErrors.email = true;
  if (!form.guests || Number(form.guests) < 1) newErrors.guests = true;

  return newErrors;
};

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    guests: "",
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    if (open && formRef.current) {
      gsap.fromTo(
        formRef.current.querySelectorAll(".field"),
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.08,
          ease: "power3.out",
        }
      );
    }
  }, [open]);

const handleChange = (e) => {
  const { name, value } = e.target;

  // update form
  setForm((prev) => ({ ...prev, [name]: value }));

  // remove error immediately for this field if it now has a valid value
  setErrors((prev) => {
    if (!prev[name]) return prev; // no error before, nothing to do

    let hasError = false;

    if (name === "guests") {
      hasError = !value || Number(value) < 1;
    } else {
      hasError = !value.trim();
    }

    if (!hasError) {
      const updated = { ...prev };
      delete updated[name]; // remove error for this field
      return updated;
    }

    return prev; // keep error if still invalid
  });
};


  const handleSubmit = (e) => {
  e.preventDefault();

  const validationErrors = validate();
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length > 0) {
      if (formRef.current) {
      gsap.fromTo(
        formRef.current,
        { x: -10 },
        {
          x: 10,
          duration: 0.1,
          repeat: 5,
          yoyo: true,
          ease: "power1.inOut",
        }
      );
    }
    return
  }

  const GOOGLE_SHEET_URL =
    "https://script.google.com/macros/s/AKfycbxkJ_T3fKibJgJy2Hg0u5TO8N0E1pCrAwkePRPAno-VNLQcdk6fZ_UO8IKeqQqGs9c/exec";

  fetch(GOOGLE_SHEET_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: `Name=${form.firstName} ${form.lastName}&Email=${form.email}&Phone=${form.phone}&Guests=${form.guests}&Message=${form.message}`,
  }).catch(console.error);

  setSubmitted(true);
};


  return (
    <>
      {open  && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.3s",
          }}
          onClick={() => {
            setOpen(false);
            setState(false);
          }}
        >
          <div
            className="rsvp-container"
            onClick={(e) => e.stopPropagation()}
            ref={formRef}
            style={{
    
              borderRadius: "2em",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              padding: "2em 3em 2em 3em",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 320,
            }}
          >
            <button
              className="close-btn"
              style={{
                position: "absolute",
                top: 16,
                right: 24,
                fontSize: 32,
                background: "none",
                border: "none",
                cursor: "pointer",
                zIndex: 2,
              }}
              onClick={() => {
                setOpen(false);
                setState(false);
                setSubmitted(false);
              }}
            >
              ×
            </button>

            {!submitted ? (
              <>
                <h1 >RSVP</h1>
                <form onSubmit={handleSubmit} className="rsvp-form">
               <div className="flex"><div className="field-group">                   <input
  className={`field ${errors.firstName ? "error" : ""}`}
  name="firstName"
  placeholder="First Name"
  onChange={handleChange}
/>
{errors.firstName && <small className="error-text">* required</small>}
</div>
<div className="field-group">
                <input
  className={`field ${errors.lastName ? "error" : ""}`}
  name="lastName"
  placeholder="Last Name"
  onChange={handleChange}
/>
{errors.lastName && <small className="error-text">* required</small>}
</div>
</div>
         <div className="flex">
        <div className="field-group">
                <input
  className={`field ${errors.phone ? "error" : ""}`}
  type="tel"
  name="phone"
  placeholder="Phone Number"
  onChange={handleChange}
/>
{errors.phone && <small className="error-text">* required</small>}
        </div>
<div className="field-group"><input
  className={`field ${errors.email ? "error" : ""}`}
  name="email"
  placeholder="Email Address"
  onChange={handleChange}
/>
{errors.email && <small className="error-text">
  {form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email) 
    ? "* invalid email" 
    : "* required"}
</small>}</div>
</div> 


                  
<input
  className={`field ${errors.guests ? "error" : ""}`}
  type="number"
  name="guests"
  min="1"
  placeholder="Number of Guests"
  onChange={handleChange}
/>
{errors.guests && (
  <small className="error-text">* required (minimum 1)</small>
)}

                  <textarea
                    className="field"
                    name="message"
                    placeholder="Message (optional)"
                    onChange={handleChange}
                  />
                  <RSVPButton label="Submit RSVP" style={{alignSelf: "center", width: "auto", backgroundColor: "black", }} />
                </form>
              </>
            ) : (
              <div className="success">
                <h2>Thank You!</h2>
                <p>
                  We’re so grateful you took the time to RSVP.</p><p> It truly means the
                  world to us to celebrate this special day with the people we
                  love.
                </p>
                <p>
                  We can’t wait to share laughter, love, and unforgettable
                  memories together!
                </p>
                <p className="signature">
                  With love,
                  <br />
                  Ben &amp; Mara
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
